import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { ProvidersDataList } from 'features/providers/components/ProvidersDataList';

export const ProvidersList = (): JSX.Element => {
	return (
		<Layout>
			<Container component="main" maxWidth="xl" sx={{ py: 4 }}>
				<Box sx={{ mb: 3 }}>
					<Typography variant="h5" sx={{ fontWeight: 600 }}>
						Proveedores
					</Typography>
					<Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
						Gestión de proveedores, reglas de pago y calendario
					</Typography>
				</Box>
				<ProvidersDataList />
			</Container>
		</Layout>
	);
};
